'use strict';

var validator = require('./validator.cjs.js');



exports.validate = validator.validate;
exports.validateFromFile = validator.validateFromFile;
//# sourceMappingURL=index.cjs.js.map
